import { cn } from "@devhop/ui";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useCompetitionAuth } from "@/modules/auth/presentation/model/useCompetitionAuth";

export function CompetitionAdminLayout() {
  const { isLoading, isCompetitionAdmin, isCompetitionUser, signOut } =
    useCompetitionAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isCompetitionUser) {
      navigate({ to: "/competition/login" });
    }
  }, [isLoading, isCompetitionUser, navigate]);

  if (isLoading) return null;

  if (!isCompetitionAdmin) {
    return (
      <div className="flex h-svh flex-col items-center justify-center gap-4 bg-background">
        <p className="font-bold text-foreground text-xl">ບໍ່ມີສິດທິ້ເຂົ້າເຖິງ</p>
        <p className="text-muted-foreground text-sm">ໜ້ານີ້ສໍາລັບ Admin ເທົ່ານັ້ນ</p>
        <button
          type="button"
          onClick={async () => {
            await signOut();
            navigate({ to: "/competition/login" });
          }}
          className={cn(
            "rounded-xl bg-secondary px-6 py-2 text-secondary-foreground text-sm",
            "transition-colors hover:bg-secondary/80",
          )}
        >
          ອອກຈາກລະບົບ
        </button>
      </div>
    );
  }

  return (
    <div className="flex min-h-dvh flex-col">
      <Outlet />
    </div>
  );
}
